import { createMachine } from 'xstate';

import {
  OTP_STATE_MACHINE_ID,
  otpStateMachineEvents,
  otpStateMachineStates
} from '../../constants/otpStateMachineConstants';

export type OTPStateEvent =
  | { type: 'RESEND_ENABLE' }
  | { type: 'RESEND_DISABLE' };

export interface OTPStateContext {
  isDisabled?: boolean;
}

export const otpStateMachine = () =>
  createMachine<OTPStateContext, OTPStateEvent>({
    id: OTP_STATE_MACHINE_ID,
    initial: otpStateMachineStates.RESEND_DISABLE_STATE,
    context: {},
    on: {
      [otpStateMachineEvents.RESEND_DISABLE]:
        otpStateMachineStates.RESEND_DISABLE_STATE,
      [otpStateMachineEvents.RESEND_ENABLE]:
        otpStateMachineStates.RESEND_ENABLED_STATE
    },
    states: {
      [otpStateMachineStates.RESEND_DISABLE_STATE]: {
        on: {
          [otpStateMachineEvents.RESEND_ENABLE]:
            otpStateMachineStates.RESEND_ENABLED_STATE
        }
      },
      [otpStateMachineStates.RESEND_ENABLED_STATE]: {
        on: {
          [otpStateMachineEvents.RESEND_DISABLE]:
            otpStateMachineStates.RESEND_DISABLE_STATE
        }
      }
    }
  });
